(function () {

    "use strict";

    function getList( $q, $rootScope, $http, $resource, URL) {
       
        var self = this;
        self.getList = $resource(URL.URL + '/api/documentary/valuelist/:id', { id: '@_id' }, {
            update: {
                method: 'PUT'
            },
            queryPaged: {
                method: 'GET'
            }
        });
   
    }

    getList.$inject = ["$q", "$rootScope", "$http", "$resource", "URL"];

    angular.module("solpheo").service("solpheo.getList", getList);

})();


